import { useChecklistSummaryDrawer } from '@/components_v2/ChecklistSummary';
import { gql } from '@/gql';
import { useToast } from '@chakra-ui/react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import React from 'react';

const updateTicketStatusMutation = gql(`#graphql
  mutation HideTask($input: HideTaskInput!) {
    hideTask(input: $input) {
      errors
    }
  }
`);

export const useUpdateTicketStatus = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const [mutate, payload] = useMutation(updateTicketStatusMutation);
  const { closeDrawer } = useChecklistSummaryDrawer();

  const updateTicketStatus = React.useCallback(
    async (input: HideTaskInput) => {
      const result = await mutate({
        variables: {
          input,
        },
      });

      const { data, errors } = result;

      if (data || errors) {
        toast({
          title: errors
            ? t('toast_messages.status_update_failed')
            : t('toast_messages.status_updated'),
          status: errors ? 'error' : 'success',
        });
      }

      if (!errors) {
        closeDrawer();
      }

      return result;
    },
    [mutate, toast, closeDrawer],
  );

  return {
    updateTicketStatus,
    ...payload,
  };
}
